// src/pages/GetTheApp.js
import React, { useEffect, useState } from 'react';

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#FAF7F2',
    fontFamily: "'Segoe UI', system-ui, sans-serif",
  },
  header: {
    padding: '24px 24px 0',
    maxWidth: '680px',
    margin: '0 auto',
  },
  nav: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '40px',
  },
  back: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '14px',
    color: '#7A9E87',
    textDecoration: 'none',
    fontWeight: '500',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
  },
  logo: {
    fontSize: '20px',
    fontWeight: '700',
  },
  logoAppt: { color: '#2C2C2A' },
  logoNote: { color: '#D4A5A5' },
  hero: {
    textAlign: 'center',
    marginBottom: '48px',
    padding: '40px 0 0',
  },
  heroIcon: {
    fontSize: '56px',
    marginBottom: '16px',
  },
  heroTitle: {
    fontSize: '32px',
    fontWeight: '800',
    color: '#2C2C2A',
    lineHeight: '1.2',
    marginBottom: '12px',
  },
  heroSub: {
    fontSize: '16px',
    color: '#4a6070',
    lineHeight: '1.6',
    maxWidth: '420px',
    margin: '0 auto',
  },
  benefitsRow: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: '24px 0 0',
  },
  benefit: {
    background: '#F0F5F2',
    borderRadius: '20px',
    padding: '8px 16px',
    fontSize: '13px',
    fontWeight: '600',
    color: '#7A9E87',
  },
  divider: {
    border: 'none',
    borderTop: '1px solid #E8E2D9',
    margin: '0 0 40px',
  },
  section: {
    marginBottom: '32px',
  },
  sectionLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '16px',
  },
  sectionIcon: {
    width: '36px',
    height: '36px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    flexShrink: 0,
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#2C2C2A',
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    border: '1px solid #F0EAE2',
    overflow: 'hidden',
    marginBottom: '16px',
  },
  stepList: {
    padding: '0',
    margin: '0',
    listStyle: 'none',
  },
  step: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    padding: '20px 24px',
    borderBottom: '1px solid #F5F0EA',
  },
  stepLast: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    padding: '20px 24px',
  },
  stepNumber: {
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    background: '#7A9E87',
    color: 'white',
    fontSize: '13px',
    fontWeight: '700',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginTop: '1px',
  },
  stepContent: {
    flex: 1,
  },
  stepTitle: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#2C2C2A',
    marginBottom: '4px',
  },
  stepDesc: {
    fontSize: '14px',
    color: '#4a6070',
    lineHeight: '1.5',
  },
  stepEmoji: {
    fontSize: '20px',
    flexShrink: 0,
    marginTop: '2px',
  },
  tipBox: {
    background: '#F0F5F2',
    borderRadius: '12px',
    padding: '16px 20px',
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start',
    marginTop: '8px',
  },
  tipIcon: {
    fontSize: '18px',
    flexShrink: 0,
  },
  tipText: {
    fontSize: '14px',
    color: '#4a6070',
    lineHeight: '1.5',
  },
  notifCard: {
    background: 'white',
    borderRadius: '16px',
    border: '1px solid #F0EAE2',
    padding: '24px',
    marginBottom: '16px',
  },
  notifTitle: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#2C2C2A',
    marginBottom: '6px',
  },
  notifDesc: {
    fontSize: '14px',
    color: '#4a6070',
    lineHeight: '1.5',
    marginBottom: '16px',
  },
  notifButton: {
    background: '#7A9E87',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    width: '100%',
  },
  notifGranted: {
    background: '#F0F5F2',
    borderRadius: '10px',
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#7A9E87',
    textAlign: 'center',
  },
  whyCard: {
    background: 'white',
    borderRadius: '16px',
    border: '1px solid #F0EAE2',
    padding: '24px',
    marginBottom: '32px',
  },
  whyTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#2C2C2A',
    marginBottom: '16px',
  },
  whyItem: {
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start',
    marginBottom: '14px',
  },
  whyEmoji: {
    fontSize: '20px',
    flexShrink: 0,
  },
  whyText: {
    fontSize: '15px',
    color: '#4a6070',
    lineHeight: '1.5',
  },
  whyBold: {
    fontWeight: '600',
    color: '#2C2C2A',
  },
  cta: {
    background: '#2C2C2A',
    borderRadius: '16px',
    padding: '32px 28px',
    marginBottom: '80px',
    textAlign: 'center',
  },
  ctaTitle: {
    fontSize: '20px',
    fontWeight: '700',
    color: 'white',
    marginBottom: '8px',
  },
  ctaText: {
    fontSize: '15px',
    color: '#9aaa98',
    lineHeight: '1.6',
    marginBottom: '24px',
  },
  ctaButton: {
    display: 'inline-block',
    background: '#7A9E87',
    color: 'white',
    padding: '14px 32px',
    borderRadius: '10px',
    fontWeight: '600',
    fontSize: '16px',
    border: 'none',
    cursor: 'pointer',
  },
};

export default function GetTheApp({ onBack, onStartTracking }) {
  const [notifPermission, setNotifPermission] = useState(
    typeof Notification !== 'undefined' ? Notification.permission : 'default'
  );

  useEffect(() => {
    document.title = 'Get the App — ApptNote';
  }, []);

  const requestNotifications = async () => {
    if (typeof Notification === 'undefined') return;
    const permission = await Notification.requestPermission();
    setNotifPermission(permission);
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>

        {/* Nav */}
        <div style={styles.nav}>
          <button style={styles.back} onClick={onBack}>← Back to ApptNote</button>
          <div style={styles.logo}>
            <span style={styles.logoAppt}>Appt</span>
            <span style={styles.logoNote}>Note</span>
          </div>
        </div>

        {/* Hero */}
        <div style={styles.hero}>
          <div style={styles.heroIcon}>📱</div>
          <h1 style={styles.heroTitle}>Add ApptNote<br />to your home screen</h1>
          <p style={styles.heroSub}>
            Get the full app experience — faster access, daily reminders,
            and it works just like a native app on your phone.
          </p>
          <div style={styles.benefitsRow}>
            <span style={styles.benefit}>⚡ Faster access</span>
            <span style={styles.benefit}>🔔 Daily reminders</span>
            <span style={styles.benefit}>📴 Works offline</span>
            <span style={styles.benefit}>🌿 No app store needed</span>
          </div>
        </div>

        <hr style={styles.divider} />

        {/* Why section */}
        <div style={styles.whyCard}>
          <p style={styles.whyTitle}>Why add it to your home screen?</p>
          <div style={styles.whyItem}>
            <span style={styles.whyEmoji}>⚡</span>
            <p style={styles.whyText}><span style={styles.whyBold}>One tap to log.</span> No typing in a URL, no searching your browser history. It's right there on your home screen every morning.</p>
          </div>
          <div style={styles.whyItem}>
            <span style={styles.whyEmoji}>🔔</span>
            <p style={styles.whyText}><span style={styles.whyBold}>Daily reminders work better.</span> Push notifications only work reliably when the app is installed on your home screen.</p>
          </div>
          <div style={styles.whyItem}>
            <span style={styles.whyEmoji}>📊</span>
            <p style={styles.whyText}><span style={styles.whyBold}>Better insights.</span> Consistent daily logging is what powers your AI pattern analysis. The easier it is to open, the more you'll log.</p>
          </div>
          <div style={styles.whyItem}>
            <span style={styles.whyEmoji}>🔒</span>
            <p style={styles.whyText}><span style={styles.whyBold}>No app store needed.</span> Nothing to download or update. Just tap and go.</p>
          </div>
        </div>

        {/* iOS Instructions */}
        <div style={styles.section}>
          <div style={styles.sectionLabel}>
            <div style={{ ...styles.sectionIcon, background: '#F0F5F2' }}>🍎</div>
            <p style={styles.sectionTitle}>iPhone & iPad (Safari)</p>
          </div>
          <div style={styles.card}>
            <ul style={styles.stepList}>
              <li style={styles.step}>
                <div style={styles.stepNumber}>1</div>
                <div style={styles.stepContent}>
                  <p style={styles.stepTitle}>Open Safari</p>
                  <p style={styles.stepDesc}>Make sure you're using Safari — this won't work in Chrome or Firefox on iPhone.</p>
                </div>
                <span style={styles.stepEmoji}>🧭</span>
              </li>
              <li style={styles.step}>
                <div style={styles.stepNumber}>2</div>
                <div style={styles.stepContent}>
                  <p style={styles.stepTitle}>Tap the Share button</p>
                  <p style={styles.stepDesc}>The square with an arrow pointing upward at the bottom of your screen.</p>
                </div>
                <span style={styles.stepEmoji}>⬆️</span>
              </li>
              <li style={styles.step}>
                <div style={styles.stepNumber}>3</div>
                <div style={styles.stepContent}>
                  <p style={styles.stepTitle}>Scroll down and tap "Add to Home Screen"</p>
                  <p style={styles.stepDesc}>You may need to scroll down in the share menu to find this option.</p>
                </div>
                <span style={styles.stepEmoji}>➕</span>
              </li>
              <li style={styles.stepLast}>
                <div style={styles.stepNumber}>4</div>
                <div style={styles.stepContent}>
                  <p style={styles.stepTitle}>Tap "Add"</p>
                  <p style={styles.stepDesc}>ApptNote will appear on your home screen just like any other app.</p>
                </div>
                <span style={styles.stepEmoji}>✅</span>
              </li>
            </ul>
          </div>
          <div style={styles.tipBox}>
            <span style={styles.tipIcon}>💡</span>
            <p style={styles.tipText}>If you don't see "Add to Home Screen", make sure you're on apptnote.com in Safari — not in a different browser.</p>
          </div>
        </div>

        {/* Android Instructions */}
        <div style={styles.section}>
          <div style={styles.sectionLabel}>
            <div style={{ ...styles.sectionIcon, background: '#F0F5F2' }}>🤖</div>
            <p style={styles.sectionTitle}>Android (Chrome)</p>
          </div>
          <div style={styles.card}>
            <ul style={styles.stepList}>
              <li style={styles.step}>
                <div style={styles.stepNumber}>1</div>
                <div style={styles.stepContent}>
                  <p style={styles.stepTitle}>Open Chrome</p>
                  <p style={styles.stepDesc}>Make sure you're visiting apptnote.com in Chrome on your Android device.</p>
                </div>
                <span style={styles.stepEmoji}>🌐</span>
              </li>
              <li style={styles.step}>
                <div style={styles.stepNumber}>2</div>
                <div style={styles.stepContent}>
                  <p style={styles.stepTitle}>Tap the three dots menu</p>
                  <p style={styles.stepDesc}>The ⋮ menu in the top right corner of Chrome.</p>
                </div>
                <span style={styles.stepEmoji}>⋮</span>
              </li>
              <li style={styles.step}>
                <div style={styles.stepNumber}>3</div>
                <div style={styles.stepContent}>
                  <p style={styles.stepTitle}>Tap "Add to Home screen"</p>
                  <p style={styles.stepDesc}>Or you may see "Install app" — either option works.</p>
                </div>
                <span style={styles.stepEmoji}>➕</span>
              </li>
              <li style={styles.stepLast}>
                <div style={styles.stepNumber}>4</div>
                <div style={styles.stepContent}>
                  <p style={styles.stepTitle}>Tap "Add" or "Install"</p>
                  <p style={styles.stepDesc}>ApptNote will appear on your home screen and in your app drawer.</p>
                </div>
                <span style={styles.stepEmoji}>✅</span>
              </li>
            </ul>
          </div>
          <div style={styles.tipBox}>
            <span style={styles.tipIcon}>💡</span>
            <p style={styles.tipText}>On some Android devices Chrome may show a banner at the bottom of the screen automatically — just tap "Install" when you see it.</p>
          </div>
        </div>

        {/* Push Notifications */}
        <div style={styles.section}>
          <div style={styles.sectionLabel}>
            <div style={{ ...styles.sectionIcon, background: '#FFF5F5' }}>🔔</div>
            <p style={styles.sectionTitle}>Enable daily reminders</p>
          </div>
          <div style={styles.notifCard}>
            <p style={styles.notifTitle}>Get a gentle nudge every day</p>
            <p style={styles.notifDesc}>
              ApptNote sends a daily reminder at 7pm if you haven't logged yet.
              Consistent tracking is what makes your AI insights powerful —
              the more you log, the more patterns emerge.
            </p>
            {notifPermission === 'granted' ? (
              <div style={styles.notifGranted}>
                ✅ Reminders are enabled — you're all set!
              </div>
            ) : notifPermission === 'denied' ? (
              <div style={styles.tipBox}>
                <span style={styles.tipIcon}>💡</span>
                <p style={styles.tipText}>
                  Notifications are blocked. To enable them, go to your browser settings,
                  find apptnote.com under Site Settings, and allow notifications.
                </p>
              </div>
            ) : (
              <button style={styles.notifButton} onClick={requestNotifications}>
                Enable daily reminders 🔔
              </button>
            )}
          </div>
          <div style={styles.tipBox}>
            <span style={styles.tipIcon}>🌿</span>
            <p style={styles.tipText}>
              Reminders only send if you haven't logged that day — we'll never spam you.
              You can unsubscribe at any time from any reminder email.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div style={styles.cta}>
          <p style={styles.ctaTitle}>Ready to start tracking?</p>
          <p style={styles.ctaText}>
            Log your symptoms daily, spot your patterns, and walk into
            your next appointment with a clear record of how you've been.
          </p>
          <button style={styles.ctaButton} onClick={onStartTracking}>
            Start tracking free →
          </button>
        </div>

      </div>
    </div>
  );
}
